import React, {FC, useState} from 'react'
import {useStatusMessage} from '../../../features'
import {Post} from '../../../../setup'
import {useFormik} from 'formik'

interface UpdateNoteInterface {
  notes: string
  id: string
}

const initialValues = {
  notes: '',
}

const CREATE_NOTE = process.env.REACT_APP_WEB_FORMS_CREATE_NOTE

const UpdateNotes: FC<UpdateNoteInterface> = ({id, notes}) => {

  const {formState, setLoading} = useStatusMessage()
  const [successReq, setSuccessReq] = useState<boolean>(false)
  const endpoint = `${CREATE_NOTE}/${id}`

  const onSubmit = async (values: typeof initialValues, {setSubmitting}: {
    setSubmitting: (isSubmitting: boolean) => void
  }) => {

    setLoading(true)

    try {
      const {status} = await Post<any>(endpoint, values)

      if (status === 200) {
        setSuccessReq(true)
        setTimeout(() => {
          setSuccessReq(false)
        }, 3000)
      }

    } catch (err) {
      console.error('Error submitting the form:', err)
    } finally {
      setLoading(false)
      setSubmitting(false)
    }
  }

  const formik = useFormik({
    initialValues: {notes: notes || ''},
    enableReinitialize: true,
    onSubmit,
  })

  return (
    <>
      <form onSubmit={formik.handleSubmit}>
        <div className="row">
          <div className="col-12">
            <div className="flex-grow-1 me-2 mb-1">
              <label htmlFor="updateStatus" className="text-muted fw-bold d-block">Ajouter une Note</label>
            </div>
            <textarea className="form-control mb-3"
                      id={`note_${id}`}
                      rows={10} cols={33}
                      {...formik.getFieldProps('notes')}
            >
                      </textarea>
          </div>
          <div className="col-12 d-flex justify-content-end align-items-center">
            <button type="submit" className={`btn btn-sm btn-${successReq ? 'success' : 'primary'}`}
                    disabled={formState.loading}
            >
              {formState.loading ? (
                <span className="indicator-progress d-block">
                    S'il vous plaît, attendez... <span className="spinner-border spinner-border-sm align-middle ms-2" />
                  </span>
              ) : (
                'Sauvegarder'
              )}
            </button>
          </div>
        </div>


      </form>
    </>
  )
}

export {UpdateNotes}